export default {
	state: {
		leagueSearchFilters: {
			cities: [] as string[],
			country: '',
			isActive: true,
			isArchived: false,
			isFinished: false,
			isPlanned: true,
			locations: [] as string[],
			playerType: 'all' as 'all' | 'mens' | 'womens' | 'students' | 'company and friends' | 'coed',
			searchField: '',
			sortBy: 'Results Needed',
		},
		finalsFilter: {
			searchField: '',
			selectedCity: null,
			selectedCountry: null,
			selectedLocation: null,
			showFilters: false,
			isActive: true,
			isArchived: true,
			isFinished: true,
			isPlanned: true,
			sortBy: 'Date DESC',
		},
		friendliesFilters: {
			searchField: '',
			country: null as string | null,
			city: null as string | null,
			player_type: null as string | null,
			format: null as string | null,
			showFilters: false,
		},
		teamsFilters: {
			searchField: '',
			country: null,
			selectedCities: [{ id: null, name: 'All' }] as any[],
			type: [{ id: null, name: 'All' }] as any[],
			teamSize: [{ id: null, name: 'All' }] as any[],
			showFilters: false as boolean,
		},
		manOfTheMatchSearchFilters: {
			cities: [] as string[],
			country: '',
			searchField: '',
			sortBy: 'Date DESC',
		},
	},

	// ================ Getters ================
	getters: {
		leagueSearchFilters(state: any) {
			return state.leagueSearchFilters;
		},
		finalsFilter(state: any) {
			return state.finalsFilter;
		},
		friendliesFilters(state: any) {
			return state.friendliesFilters;
		},
		teamsFilters(state: any) {
			return state.teamsFilters;
		},
		manOfTheMatchSearchFilters(state: any) {
			return state.manOfTheMatchSearchFilters;
		},
	},

	// ================ Mutations ================
	mutations: {
		setLeagueSearchFilters(state: any, leagueSearchFilters: any) {
			state.leagueSearchFilters = leagueSearchFilters;
		},
		resetLeagueSearchFilters(state: any) {
			state.leagueSearchFilters = {
				cities: [],
				country: '',
				isActive: true,
				isArchived: false,
				isFinished: false,
				isPlanned: true,
				locations: [],
				playerType: 'all',
				searchField: '',
				sortBy: 'Results Needed',
			};
		},
		setFinalsFilter(state: any, finalsFilter: any) {
			state.finalsFilter = finalsFilter;
		},
		resetFinalsSearchFilters(state: any) {
			state.finalsFilter = {
				searchField: '',
				selectedCity: null,
				selectedCountry: null,
				selectedLocation: null,
				showFilters: false,
				sortBy: 'Date DESC',
			};
		},
		setFriendliesFilters(state: any, friendliesFilters: any) {
			state.friendliesFilters = friendliesFilters;
		},
		resetFriendliesFilters(state: any) {
			state.friendliesFilters = {
				searchField: '',
				country: null,
				city: null,
				player_type: null,
				format: null,
				showFilters: false,
			};
		},
		setTeamsFilters(state: any, teamsFilters: any) {
			state.teamsFilters = teamsFilters;
		},
		resetTeamsFilters(state: any) {
			state.teamsFilters = {
				searchField: '',
				country: null,
				selectedCities: [{ id: null, name: 'All' }],
				type: [{ id: null, name: 'All' }],
				teamSize: [{ id: null, name: 'All' }],
				showFilters: false,
			};
		},
		setManOfTheMatchSearchFilters(state: any, manOfTheMatchSearchFilters: any) {
			state.manOfTheMatchSearchFilters = manOfTheMatchSearchFilters;
		},
		resetManOfTheMatchSearchFilters(state: any) {
			state.manOfTheMatchSearchFilters = {
				cities: [],
				country: '',
				searchField: '',
				sortBy: 'Date DESC',
			};
		},
	},

	// ================= Actions =================
	actions: {},
};
